import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {userStateMissing_template} from "./userStateMissing_template";

declare var ko: any;

export class appHeader_template extends vnTemplate {

    protected userStateMissingTemplate: userStateMissing_template;
    protected getTemplateHtml(): string {

        return /* html */`
            <!-- ko if: showMissingState() -->
                ${ this.userStateMissingTemplate.getHtmlBuild() }
            <!-- /ko -->
            <div class="w-left">
                <span class="page-title-logo" data-bind="css: brandClass"></span>
                <h2 class="page-title logo">
                    <span class="prop-title" data-bind="text: brandName"></span>
                    <span style="font-size: 1.2rem;" data-bind="text: headerTitle"></span>
                </h2>
            </div>

            <div class="w-compensation" data-bind="visible: isSessionTrackerVisible(), css: { 'output-success': articleGoalProgressPercentage() == 100 }">
                <div class="w-compensation-info">
                    <div class="compensation-card" data-bind="css: { 'compensation-success': articleGoalProgressPercentage() == 100 }">
                        <div class="label">Output</div>
                        <div class="value" data-bind="text: articleCount"></div>
                    </div>
                    <div class="compensation-card" data-bind="css: { 'compensation-success': sessionGoalProgressPercentage() == 100 }">
                        <div class="label">S/A</div>
                        <div class="value" data-bind="text: sessionsPerArticle"></div>
                    </div>
                </div>
                <div class="w-compensation-popover" data-bind="css: { 'with-monetization': selectedView() == 'currency', 'brand' : selectedView() == 'brand' }">
                    <div class="w-compensation-content">
                        <div class="w-compensation-title" data-bind="text: trackerTitle"></div>
                        <div class="w-compensation-metric hidden-for-brand">Here's your progress this month so far.</div>
                        <div class="w-compensation-metric show-for-brand">Here's how your articles have performed against the brand target.</div>
                    </div>
                    <div class="w-controls">
                        <label>
                            <input type="radio" name="controls" id="currencyView" value="currency" data-bind="checked: selectedView, event: { click: onClickSelectView}" />
                            <span class="icon i-currency"></span>
                        </label>
                        <label data-bind="visible:  brandSessionTarget() != null">
                            <input type="radio" name="controls" id="brandView" value="brand" data-bind="checked: selectedView, event: { click: onClickSelectView }" />
                            <span data-bind="css: 'full-icon compensation-icon i-' + brandShortName()"></span>
                        </label>
                    </div>
                    <div class="w-compensation-tracker">
                        <div class="compensation-output">
                            <div>
                                <div class="label" style="margin-bottom: 4px;">Output</div>
                                <div class="value-article-output">
                                    <div class="value-article-fill" data-bind="style: { height: articleGoalProgressPercentage() + '%'}, css: { 'progress-full': articleGoalProgressPercentage() == 100 }"></div>
                                    <div class="value" data-bind="text: articleCount"></div>
                                </div>
                            </div>
                            <div class="hidden-for-brand">
                                <div class="label">Target</div>
                                <div class="label" data-bind="text: articleGoal()"></div>
                            </div>
                            <div class="exceeded-earnings" data-bind="visible: outputTransactionsTotal() != 0">
                                <div class="label">Additional <br> Output <br> Comp.</div>
                                <div class="label" style="font-size: 12px;" data-bind="text: '$' + outputTransactionsTotal()"></div>
                            </div>
                        </div>
                        <div class="compensation-sessions">
                            <div class="sessions-label">Sessions per Article
                                    <span class="performance-value" data-bind="text: sessionsPerArticle"></span>
                            </div>
                            <div class="sessions-performance">
                                <div class="sessions-performance-inner hidden-for-brand">

                                    <div class="performance-progress-bar">
                                        <div class="progress-bar-fill" data-bind="style: { '--pos': sessionGoalProgressPercentage() + '%'}, css: { 'single-tier': !isUserHasTier2Rates(), 'tier-one-success': sessionGoalProgressPercentage() == 100, 'tier-two-success': tier2SessionGoalProgressPercentage() == 100 }">
                                            <div class="w-user-img">
                                               <img class="user-img" data-bind="attr:{src: userPicture}" src="/assets/images/default-user.png">
                                            </div>
                                        </div>
                                        <div class="tier">
                                            <span class="tier-label">Tier 1</span>
                                            <span class="tier-value" data-bind="text: sessionsPerArticleTarget()"></span>
                                            <div class="tier-monetization icon i-lock" data-bind="text: '$' + tier1Amount()"></div>
                                        </div>
                                        <div class="tier" data-bind="visible: isUserHasTier2Rates()">
                                            <span class="tier-label">Tier 2</span>
                                            <span class="tier-value" data-bind="text: tier2SessionsPerArticleTarget()"></span>
                                            <div class="tier-monetization icon i-lock" data-bind="text: '$' + tier2Amount()"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sessions-performance-inner show-for-brand">
                                    <div class="performance-progress-bar">
                                        <div class="progress-bar-fill" data-bind="style: { '--pos': brandProgressPercentage() + '%'}">
                                            <div class="w-user-img">
                                                <img class="user-img" data-bind="attr:{src: userPicture}" src="/assets/images/default-user.png">
                                            </div>
                                        </div>
                                        <div class="tier" data-bind="visible: brandContentTypeSessionTarget() != null, style: { '--pos': contentTypeProgressPercentage() + '%', 'left' : 'var(--pos)'}">
                                            <span class="tier-label" data-bind="html: contentTypeName() + ' <br> ' + brandContentTypeSessionTarget()"></span>
                                        </div>
                                        <div class="tier flipped" style="--pos: 80%; left: var(--pos);">
                                            <span class="tier-label" data-bind="html: 'Brand <br> ' + brandSessionTarget()"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="message-box" data-bind="text: explanationText"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-right" data-bind="foreach: menuItems">
    <!--            <a class="btn annon icon i-notice-alert" href="/announcement" data-bind="visible: isAnnouncementVisible" >announcement</a>-->
                <div class="dropdown" >
                    <button data-bind="attr: {class: 'btn no-bg dropdown-toggle icon i-dropdown-simple ' + cssClass}">
                        <!-- ko if: url -->
                            <a data-bind="text: text, attr: {href: url}"></a>
                        <!-- /ko -->
                        <!-- ko ifnot: url -->
                            <span data-bind="text: text"></span>
                        <!-- /ko -->
                    </button>
                    <ul class="dropdown-list" data-bind="foreach: subMenus" >
                         <li class="dropdown-item">
                            <a data-bind="text: text, attr: {href: url, class: 'dropdown-link icon ' + cssClass}"></a>
                        </li>
                    </ul>
                </div>
            </div>
            <button style="padding-left: 20px;" data-bind="event: { click: onClickLogOutAction}" class="btn no-bg icon i-logout">log out</button>
        `;
    }

    protected initPartial(): void {
        this.userStateMissingTemplate = new userStateMissing_template('userStateMissingTemplate', this.getTemplateViewModel(), this.caller);
        this.userStateMissingTemplate.setUrlPath('/users/edit/');
    }

    protected getTemplateName(): string {
        return "appHeader-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["main-header", "w-justify"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            userPicture: ko.observable(""),
            userFullName: ko.observable(""),
            profileLink: ko.observable(""),
            projectsCount: ko.observable(""),
            totalEarnings: ko.observable(""),
            headerTitle: ko.observable(""),
            brandClass: ko.observable(""),
            brandName: ko.observable(""),
            brandShortName: ko.observable(""),
            brandDomain:  ko.observable(""),
            roleName:  ko.observable(""),
            contentTypeName: ko.observable(""),
            monthName:  ko.observable(""),
            isUserStatsVisible: ko.observable(false),
            isSessionTrackerVisible: ko.observable(false),
            isUserHasTier2Rates: ko.observable(false),
            menuItems: ko.observableArray([]),
            showMissingState:  ko.observable(false),
            articleCount: ko.observable(0),
            sessionsPerArticle: ko.observable(0),
            articleGoal: ko.observable(0),
            articleGoalProgressPercentage: ko.observable(0),
            sessionGoalProgressPercentage: ko.observable(0),
            tier2SessionGoalProgressPercentage: ko.observable(0),
            sessionsPerArticleTarget: ko.observable(0),
            tier2SessionsPerArticleTarget: ko.observable(0),
            tier1Amount: ko.observable(0),
            tier2Amount: ko.observable(0),
            outputTransactionsTotal: ko.observable(0),
            brandSessionTarget: ko.observable(null),
            brandProgressPercentage: ko.observable(0),
            contentTypeProgressPercentage: ko.observable(0),
            brandContentTypeSessionTarget: ko.observable(null),
            selectedView:ko.observable(null),
            trackerTitle: ko.pureComputed(() => {
                const selectedView = this.getTemplateViewModel().selectedView();
                let title = this.getTemplateViewModel().roleName() + ": " + this.getTemplateViewModel().monthName();
                if (selectedView == null) {
                    title = title + " Compensation Tracker";
                } else if (selectedView === 'currency') {
                    title = title + " Compensation Details";
                } else{
                    title = title + " Content Performance";
                }
                return title;
            }),
            explanationText: ko.pureComputed(() => {
                let articleGoalProgressPercentage = this.getTemplateViewModel().articleGoalProgressPercentage();

                let isUserHasTier2Rates = this.getTemplateViewModel().isUserHasTier2Rates();

                let text = "Output target reached, Monthly S/A bonus unlocked!";
                if(articleGoalProgressPercentage < 100){

                    let remainingArticles = this.getTemplateViewModel().articleGoal() - this.getTemplateViewModel().articleCount();

                    text = remainingArticles + " more articles are needed to be eligible for Monthly S/A bonus.";
                }

                let sessionGoalProgressPercentage = this.getTemplateViewModel().sessionGoalProgressPercentage();
                let tier2SessionGoalProgressPercentage = this.getTemplateViewModel().tier2SessionGoalProgressPercentage();
                if(sessionGoalProgressPercentage < 100){

                    let sessionsPerArticleTarget = this.getTemplateViewModel().sessionsPerArticleTarget();

                    let sessionsPerArticle = this.getTemplateViewModel().sessionsPerArticle();

                    let remainingSessions = parseFloat(String(sessionsPerArticleTarget).replace(/,/g, '')) - parseFloat(String(sessionsPerArticle).replace(/,/g, ''));

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();

                    text = text + " Improve S/A by " + remainingSessions.toLocaleString('en-US') + " in order to earn $" + tier1Amount + " bonus payout.";
                }else if(isUserHasTier2Rates && sessionGoalProgressPercentage >= 100 && tier2SessionGoalProgressPercentage < 100){

                    let sessionsPerArticleTarget = this.getTemplateViewModel().tier2SessionsPerArticleTarget();

                    let sessionsPerArticle = this.getTemplateViewModel().sessionsPerArticle();

                    let remainingSessions = parseFloat(String(sessionsPerArticleTarget).replace(/,/g, '')) - parseFloat(String(sessionsPerArticle).replace(/,/g, ''));

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();
                    let tier2Amount = this.getTemplateViewModel().tier2Amount();

                    text = text + " On track for Tier 1 bonus of $" + tier1Amount + ". Improve S/A by " + remainingSessions.toLocaleString('en-US') + " in order to each Tier 2's $" + tier2Amount + " bonus!";
                }else if(!isUserHasTier2Rates && sessionGoalProgressPercentage >= 100){

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();

                    text = text + " On track for Tier 1 bonus of $" + tier1Amount + ". Maintain this S/A through the month to earn it.";
                }else if(isUserHasTier2Rates && tier2SessionGoalProgressPercentage >= 100){

                    let tier2Amount = this.getTemplateViewModel().tier2Amount();

                    text = text + " Maxxed out for Tier 2 bonus of $" + tier2Amount + ". Maintain this S/A through the month to earn it.";
                }

                return text;
            }),
            onClickLogOutAction: function (data, event) {
                self.onClickLogOutAction();
            },
            onClickSelectView: function (data, event) {
                return self.onClickSelectView(event);
            }
        };
    }

    public setUserImageSrc(src: string): void {
        this.getTemplateViewModel().userPicture(src);
    }

    public setUserFullName(fullName: string): void {
        this.getTemplateViewModel().userFullName(fullName);
    }

    public setProfilePageLink(link: string): void {
        this.getTemplateViewModel().profileLink(link);
    }

    public setProjectsCount(projectsCount: number): void {
        this.getTemplateViewModel().projectsCount(projectsCount);
    }

    public setTotalEarnings(totalEarnings: string): void {
        this.getTemplateViewModel().totalEarnings(totalEarnings);
    }

    public setIsUserStatsVisible(isUserStatsVisible: boolean): void {
        this.getTemplateViewModel().isUserStatsVisible(isUserStatsVisible);
    }

    public setIsUserHasTier2Rates(isUserHasTier2Rates: boolean): void {
        this.getTemplateViewModel().isUserHasTier2Rates(isUserHasTier2Rates);
    }

    public setIsSessionTrackerVisible(isSessionTrackerVisible: boolean): void {
        this.getTemplateViewModel().isSessionTrackerVisible(isSessionTrackerVisible);
    }

    public setArticleGoal(articleGoal): void {
        this.getTemplateViewModel().articleGoal(articleGoal);
    }

    public setMonthName(monthName): void {
        this.getTemplateViewModel().monthName(monthName);
    }

    public setRoleName(roleName): void {
        this.getTemplateViewModel().roleName(roleName);
    }

    public setContentTypeName(contentTypeName): void {
        this.getTemplateViewModel().contentTypeName(contentTypeName);
    }

    public setArticleGoalProgressPercentage(articleGoalProgressPercentage): void {
        this.getTemplateViewModel().articleGoalProgressPercentage(articleGoalProgressPercentage);
    }

    public setSessionGoalProgressPercentage(sessionGoalProgressPercentage): void {
        this.getTemplateViewModel().sessionGoalProgressPercentage(sessionGoalProgressPercentage);
    }

    public setTier2SessionGoalProgressPercentage(tier2SessionGoalProgressPercentage): void {
        this.getTemplateViewModel().tier2SessionGoalProgressPercentage(tier2SessionGoalProgressPercentage);
    }

    public setSessionsPerArticleTarget(sessionsPerArticleTarget): void {
        this.getTemplateViewModel().sessionsPerArticleTarget(sessionsPerArticleTarget);
    }

    public setTier2SessionsPerArticleTarget(tier2SessionsPerArticleTarget): void {
        this.getTemplateViewModel().tier2SessionsPerArticleTarget(tier2SessionsPerArticleTarget);
    }

    public setTier1Amount(tier1Amount): void {
        this.getTemplateViewModel().tier1Amount(tier1Amount);
    }

    public setTier2Amount(tier2Amount): void {
        this.getTemplateViewModel().tier2Amount(tier2Amount);
    }

    public setOutputTransactionsTotal(outputTransactionsTotal): void {
        this.getTemplateViewModel().outputTransactionsTotal(outputTransactionsTotal);
    }

    public setBrandSessionTarget(brandSessionTarget): void {
        this.getTemplateViewModel().brandSessionTarget(brandSessionTarget);
    }

    public setBrandProgressPercentage(brandProgressPercentage): void {
        this.getTemplateViewModel().brandProgressPercentage(brandProgressPercentage);
    }

    public setContentTypeProgressPercentage(contentTypeProgressPercentage): void {
        this.getTemplateViewModel().contentTypeProgressPercentage(contentTypeProgressPercentage);
    }

    public setBrandContentTypeSessionTarget(brandContentTypeSessionTarget): void {
        this.getTemplateViewModel().brandContentTypeSessionTarget(brandContentTypeSessionTarget);
    }

    public setArticleCount(articleCount): void {
        this.getTemplateViewModel().articleCount(articleCount);
    }

    public setSessionsPerArticle(sessionsPerArticle): void {
        this.getTemplateViewModel().sessionsPerArticle(sessionsPerArticle);
    }

    public setHeaderTitle(title: string) {
        this.getTemplateViewModel().headerTitle(title);
    }

    public setBrandClass(brandClass: string) {
        this.getTemplateViewModel().brandClass(brandClass);
    }

    public setBrandName(brandName: string) {
        this.getTemplateViewModel().brandName(brandName);
    }

    public setBrandShortName(brandShortName: string) {
        this.getTemplateViewModel().brandShortName(brandShortName);
    }

    public setBrandDomain(brandDomain: string) {
        this.getTemplateViewModel().brandDomain(brandDomain);
    }

    public setMenuItems(menuItems: Array<Object>): void {
        this.getTemplateViewModel().menuItems(menuItems);
    }

    protected onClickLogOutAction() {
        this.caller.logOut();
    }

    protected onClickSelectView(event) {

        if (event.target.dataset.wasChecked === "true") {
            event.target.dataset.wasChecked = "false";
            event.target.checked = false;
            this.getTemplateViewModel().selectedView(null);
        }else{
            event.target.dataset.wasChecked = "true";
            this.getTemplateViewModel().selectedView(event.target.value);
        }

        if(event.target.value =="currency"){
            document.getElementById('brandView').dataset.wasChecked = "false";
        }else{
            document.getElementById('currencyView').dataset.wasChecked = "false";
        }

        return true;
    }

    public setShowMissingState(show) {
        this.getTemplateViewModel().showMissingState(show);
    }

    public handleMissingUserCountryStatePopup(id, state): void {

        this.userStateMissingTemplate.setIdLoggedInUser(id);
        this.userStateMissingTemplate.buildFullHref();
        if (state) {
            this.setShowMissingState(false);
            document.body.removeAttribute('data-message');
        } else {
            this.setShowMissingState(true);
            document.body.setAttribute('data-message', 'is-site-msg');
        }

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/appHeader_template.ts